module.exports = __webpack_public_path__ + "img/plane-left-desktop.b995b022.svg";